import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getEmployees } from './api';
import type { GetEmployeesResponse, Employee } from './types';

export const EmployeesControlGate = createGate<void>();

const fxGetEmployees = createEffect<void, GetEmployeesResponse, Error>().use(
  getEmployees
);

export const employeesQuery = createQuery({
  name: 'employees',
  effect: fxGetEmployees,
  mapData: ({ result }) =>
    Array.isArray(result?.list)
      ? result.list.reduce((acc: Employee[], item) => {
          if (item?.is_archived) {
            return acc;
          }

          return [
            ...acc,
            {
              id: item?.id,
              label: item?.fullname,
            },
          ];
        }, [])
      : [],
});

sample({
  clock: EmployeesControlGate.open,
  source: EmployeesControlGate.status,
  filter: (status) => Boolean(status),
  target: employeesQuery.start,
});
